import { error, tabaPayError } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const CompleteTabapayAuthTransfer = gql`
  mutation CompleteTabapayAuthTransfer(
    $input: CompleteTabapayAuthTransferInput!
  ) {
    completeTabapayAuthTransfer(input: $input) {
      ... on CompleteTabapayAuthTransferSuccess {
        __typename
        transactionId
        transferId
      }

      ... on CompleteTabapayAuthTransferError {
        __typename
        ...error
      }

      ... on TabaPayCustomError {
        __typename
        ...tabaPayError
      }
    }
  }
  ${error}
  ${tabaPayError}
`;

export default CompleteTabapayAuthTransfer;
